import React from "react";

const ToggleMenuButton = ({ isOpen, onClick, className = "" }) => {
  const genericHamburgerLine =
    "h-[2px] w-6 my-[2px] rounded-full bg-primary transition ease transform duration-300";

  return (
    <button
      className={`flex flex-col h-12 w-12 border-none rounded justify-center items-center group z-50 ${className}`}
      onClick={onClick}
    >
      <div
        className={`${genericHamburgerLine} ${
          isOpen
            ? "rotate-45 translate-y-2 group-hover:opacity-100"
            : "opacity-100 group-hover:opacity-100"
        }`}
      />
      <div
        className={`${genericHamburgerLine} ${
          isOpen ? "opacity-0" : "opacity-100 group-hover:opacity-100"
        }`}
      />
      <div
        className={`${genericHamburgerLine} ${
          isOpen
            ? "-rotate-45 -translate-y-1 opacity-100 group-hover:opacity-100"
            : "opacity-100 group-hover:opacity-100"
        }`}
      />
    </button>
  );
};

export default ToggleMenuButton;
